import { render, staticRenderFns } from "./super-user-tool.vue?vue&type=template&id=63d1104c&scoped=true"
import script from "./super-user-tool.ts?vue&type=script&lang=ts&external"
export * from "./super-user-tool.ts?vue&type=script&lang=ts&external"
import style0 from "./super-user-tool.scss?vue&type=style&index=0&id=63d1104c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d1104c",
  null
  
)

export default component.exports